import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=756167c2&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "@/pages/assetManagement/common/style/workQQ.scss?vue&type=style&index=0&id=756167c2&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756167c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756167c2')) {
      api.createRecord('756167c2', component.options)
    } else {
      api.reload('756167c2', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=756167c2&scoped=true", function () {
      api.rerender('756167c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/workQQ/detail.vue"
export default component.exports